<div class="overlay" [ngClass]="{'show': isLoadingData}">
</div>
<div class="spanner" [ngClass]="{'show': isLoadingData}" role="status" aria-live="polite"
  [attr.aria-busy]="isLoadingData">
  <div class="spin-wrap">
    <div class="spin-wrap-content">
      <div class="spinner-container" aria-hidden="true">
        <div class="lds-ripple">
          <p *ngIf="isLoadingData && markingerrormessage && markingnotworking">{{markingerrormessage}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Question List View -->
<div class="d-flex flex-column h-100 w-100 border" role="main" *ngIf="showQuestionListView && examination.showQuestionList">
  <app-questionlist
    [scheduleid]="scheduleid"
    [examid]="examid"
    [examData]="getExamDataForQuestionList()"
    [lockedQuestions]="lockedQuestions"
    (questionClicked)="navigateToQuestion($event)"
    (backClicked)="toggleQuestionList()">
  </app-questionlist>
</div>

<!-- Question View -->
<div class="d-flex flex-column h-100 w-100 border" role="main" *ngIf="!showQuestionListView">
  <div *ngIf="adminpaused || proctorpaused"
       class="d-flex flex-column justify-content-center align-items-center p-4 h-100" role="alert" aria-live="assertive">
    <h4 tabindex="0">{{language.pleaseHold}}</h4>
    <h3 class="mt-3" tabindex="0">{{language.examHasBeenPaused}}.</h3>
    <h4 *ngIf="pausereason" class="mt-3" tabindex="0">{{language.reason}}: {{pausereason | uppercase}}</h4>
    <!-- <h5 class="mt-4" tabindex="0">{{language.willNotLoseTime}}</h5> -->
  </div>

  <!-- Question Timer Progress Bar -->
  <div *ngIf="examination.useQuestionTimer && question.questionCount
     && !adminpaused && !proctorpaused"
       style="height:5px;width:100%;flex-shrink:0;
         background:rgba(116,187,247,0.2)">
    <div [style.width.%]="questionTimerPercent"
         [class]="questionTimerClass"
         style="height:100%;transition:width 1s linear">
    </div>
  </div>

  <!-- Question Header -->
  <div class="question-header border-bottom" *ngIf="!adminpaused && !proctorpaused">
    <app-questionpageheader *ngIf="scheduleid && question.questionCount"
                            [position]="'top'"
                            [qno]="question.examQuestion.questionno"
                            [qnolabel]="question.examQuestion.questionnolabel"
                            [qCount]="question.questionCount"
                            [qcatergoy]="question.examQuestion.category"
                            [islast]="question.questionCount == question.examQuestion.questionno || (isQuestionGrouped && isLastQuestionInsideGroup)"
                            [isFirst]="question.examQuestion.questionno <= 1 || (isQuestionGrouped && isFirstQuestionInsideGroup)"
                            [scheduleid]="scheduleid"
                            [url]="this.router.url"
                            (nextclicked)="nextqclick($event)"
                            (previousclicked)="previousqclick($event)"
                            (showQuestionListClicked)="toggleQuestionList()"
                            [adminpaused]="adminpaused"
                            [proctorpaused]="proctorpaused"
                            [status]="status"
                            [exam]="examination"
                            [useProctor]="question.examination.useproctor"
                            [showQuestionList]="question.examination.showQuestionList"
                            [liteMode]="question.examination.liteMode"
                            [examid]="examid"
                            [showSubmitButtonOnEveryQuestion]="examination.showSubmitButtonOnEveryQuestion"
                            [questionTimeRemaining]="questionTimeRemaining"
                            [useQuestionTimer]="examination.useQuestionTimer"
                            [lockedQuestions]="lockedQuestions"
                            (qnoclicked)="qnoclicked($event)"
                            [isGrouped]="!!question.examQuestion.questionGroupID">
    </app-questionpageheader>
  </div>

  <!-- Question Content -->

  <div id="question-container" class="d-flex question-container border-bottom" *ngIf="!adminpaused && !proctorpaused" role="region" [attr.aria-label]="language.questionSection">
    <div *ngIf="!isQuestionGrouped" class="w-100">
      <app-question class="w-100" *ngIf="question.questionCount" [isloadingdata]="isLoadingData"
                    (quesunanswered)="quesunanswered($event)"
                    (quesanswered)="quesanswered($event)"
                    [question]="question"
                    [url]="this.router.url"
                    [adminpaused]="adminpaused"
                    [proctorpaused]="proctorpaused"
                    (quesflagged)="quesflagged($event)"
                    [status]="status"
                    [examid]="examid"
                    [scheduleid]="scheduleid"
                    [loadingSubject]="this.loadingSubject"
                    [networkFailureSubject]="this.networkFailureSubject"
                    [requiresScreenReader]="user.requiresscreenreader"
                    (nextclicked)="qnoclicked($event)"
                    (previousclicked)="qnoclicked($event)"
                    [liteMode]="question.examination.liteMode"
                    [exam]="examination"
                    (qnoclicked)="qnoclicked($event)">
      </app-question>
    </div>


    <div *ngIf="isQuestionGrouped" class="w-100">
      <app-question-group class="w-100" [isloadingdata]="isLoadingData" [seletedQuestion]="question"
                          [isQuestionGrouped]="!!question.examQuestion.questionGroupID" (quesunanswered)="quesunanswered($event)"
                          (quesanswered)="quesanswered($event)"
                          [url]="this.router.url" [adminpaused]="adminpaused"
                          [proctorpaused]="proctorpaused"
                          (quesflagged)="quesflagged($event)" [status]="status" [examid]="examid"
                          [scheduleid]="scheduleid"
                          [loadingSubject]="this.loadingSubject"
                          [networkFailureSubject]="this.networkFailureSubject"
                          [requiresScreenReader]="user.requiresscreenreader"
                          (nextclicked)="qnoclicked($event)"
                          (previousclicked)="qnoclicked($event)"
                          [liteMode]="question.examination.liteMode"
                          (hasLastQuestionInGroup)="handleLastQuestion($event)"
                          (hasFirstQuestionInGroup)="handleFirstQuestion($event)"
                          (activeQuestionChanged)="handleActiveGroupQuestion($event)">
      </app-question-group>
    </div>
    <!-- bookmark button -->
    <button *ngIf="question.questionCount" class="badge-flagged bookmark-float" [title]="language.flagQuestionToRevisit"
            [ngClass]="{'badge-unanswered':! question.examQuestion.flagged ,'badge-flagged': question.examQuestion.flagged }"
            (click)="flagQuestionForReview()" [attr.aria-pressed]="question.examQuestion.flagged">
      <i class="fa fa-flag fa-lg" aria-hidden="true"></i>
    </button>

    <!-- calculator button -->
    <button *ngIf="usecalc" class="calculator-float" [title]="language.toggleCalculator" (click)="toggleCalculator()"
            [attr.aria-label]="language.toggleCalculator">
      <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Question Footer -->
  <div class="question-footer mt-auto border-top py-1 px-2" *ngIf="!adminpaused && !proctorpaused">
    <app-questionpagefooter #quesfooter *ngIf="question.questionCount"
                            [qno]="question.examQuestion.questionno"
                            [noofquestions]="question.questionCount"
                            [scheduleid]="examination.scheduleid"
                            [examid]="examination.examid"
                            [schedulequestionid]="question.examQuestion.schedulequestionid"
                            [questions]="dummyQuestionsForFooter"
                            (qnoclicked)="qnoclicked($event)"
                            [liteMode]="question.examination.liteMode"
                            [url]="this.router.url"
                            [exam]="examination"
                            [showSubmitButtonOnEveryQuestion]="examination.showSubmitButtonOnEveryQuestion"
                            [lockedQuestions]="lockedQuestions">
    </app-questionpagefooter>
  </div>
</div>

<!-- Calculator Modal -->
<div *ngIf="isCalculatorVisible" class="calculator-container shadow-sm border rounded bg-white"
  [style.transform]="'translate(-50%, -50%)'" cdkDragBoundary=".inner_exam_wrap" cdkDrag role="dialog" aria-modal="true"
  aria-labelledby="calculatorHeader">
  <div class="calculator-header d-flex justify-content-between align-items-center p-2 bg-light" id="calculatorHeader"
    cdkDragHandle>
    <h5 class="mb-0">Calculator</h5>
    <button type="button" class="close" [attr.aria-label]="language.closeCalculator" (click)="toggleCalculator()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="p-0">
    <app-scientific-calc-v3 *ngIf="calcmode === 'Scientific'"></app-scientific-calc-v3>
    <app-calculator *ngIf="calcmode === 'Simple'"></app-calculator>
  </div>
</div>

<!-- Exam Instruction Modal -->
<app-instructions-modal [modalId]="'instructionsModal' + examid" [examId]="examid" [examName]="examination.name"
                        [company]="instructions.company" [companyHTML]="companyhtml" [examHTML]="examhtml" [webtestHTML]="webtesthtml"
                        [viewMode]="true">
</app-instructions-modal>

<!-- Confirm Navigate Away Modal -->
<ng-template #confirmNavigateModal let-modal>
  <div class="modal-header py-2">
    <h5 class="modal-title">{{language.unansweredQuestionModalTitle}}</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center py-3">
    <p class="mb-0">{{language.unansweredQuestionModalBody}}</p>
    <p class="mt-2 mb-0">{{language.unansweredQuestionModalWarning}}</p>
  </div>
  <div class="modal-footer py-2">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()">{{language.stayOnQuestion}}</button>
    <button type="button" class="btn btn-danger btn-sm" (click)="modal.close()">{{language.continue}}</button>
  </div>
</ng-template>
